export default __webpack_public_path__ + "static/media/sort-up.0d7a60cc.svg";